import { render } from "./TechnicalSpecs.vue?vue&type=template&id=e64f4a5a&scoped=true"
import script from "./TechnicalSpecs.vue?vue&type=script&lang=js"
export * from "./TechnicalSpecs.vue?vue&type=script&lang=js"

import "./TechnicalSpecs.vue?vue&type=style&index=0&id=e64f4a5a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64f4a5a"]])

export default __exports__